// extracted by mini-css-extract-plugin
export default {"isActive":"SideMenu_isActive__wl4Mh","isLink":"SideMenu_isLink__Bn22K"};